import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
// Side-effect import: rehydrates the theme and attaches the
// prefers-color-scheme listener from app start
import './store/themeStore'
import { lockZoom } from './lib/lockZoom'

// Block pinch-zoom on mobile (the HUD layout doesn't survive scaling)
lockZoom()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
